import React from "react";

const SharedDialogContext = React.createContext();

export default SharedDialogContext;